import { HTTPapi, HTTP, HTTPapiLocal, HTTPapiPublic } from './http-common'
import * as Sentry from '@sentry/browser'
import { EventBus } from 'pevueglobal'
import axios from 'axios'
import { format, differenceInDays } from 'date-fns'
import { createClient } from '@urql/core'
import jwtDecode from 'jwt-decode'

import { nl, fr } from 'date-fns/locale'
// utility class met veel gebruikte functies

axios.defaults.withCredentials = true

export function guid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    let r = (Math.random() * 16) | 0
    let v = c === 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}

// google Analytics
export function GoogleAnalytics(websiteid) {
  const googleAnalyticsScript = document.createElement('SCRIPT')
  googleAnalyticsScript.setAttribute('src', 'https://www.googletagmanager.com/gtag/js?id=' + websiteid)
  googleAnalyticsScript.setAttribute('async', '')
  googleAnalyticsScript.setAttribute('defer', '')
  document.head.appendChild(googleAnalyticsScript)

  let userid = UgetCookie('kongapikey')
  window.dataLayer = window.dataLayer || []

  function gtag() {
    window.dataLayer.push(arguments)
  }
  gtag('js', new Date())

  gtag('config', websiteid, { anonymize_ip: true })
  if (userid !== '') {
    gtag('set', { user_id: userid }) // De gebruikers-ID instellen op basis van de ingelogde user_id.
  }
}

var performance = false
export function SetPerfMeasureOn() {
  performance = true
}
export function SetPerfMeasureOff() {
  performance = false
}
export function SetMark(name) {
  if (performance) {
    window.performance.mark(name)
  }
}
export function Clearperf() {
  window.performance.clearMarks()
}
export function showperfstats() {
  if (performance) {
    console.table(window.performance.getEntriesByType('mark'))
  }
}
/**
 * Error handler voor Sentry
 *
 * @export
 * @param {string} [errorStr=""] String
 * @param {any} [metadata={}] Object of array met metadata
 * @param {string} [CustomerError=''] foutmelding die aan de klant word getoond
 */
export function throwException(errorStr = '', metadata = {}, CustomerError = 0) {
  Sentry.captureException(new Error(errorStr), {
    logger: 'Vue app',
    extra: metadata
  })
  EventBus.$emit('apperror', CustomerError)
}

/**
 * functie om een decimale string uit db om te zetten naar een leesbare decimale string
 *
 * @export
 * @param {any} decimalVal - A string with a decimal
 * @returns formatted string decimal, if it is not a int or float a normal string is returned
 */
export function FormatStringDecimal(decimalVal) {
  if (decimalVal !== null && !isNaN(decimalVal)) {
    decimalVal = parseFloat(decimalVal).toLocaleString(GetCulture())
  }
  return decimalVal
}

export function DateForDatabase(date) {
  if (date === null || date === '') {
    return null
  } else {
    if ((date instanceof Date && !isNaN(date)) === false) {
      return null
    }
    return format(date, "yyyy-MM-dd'T'HH:mm:ss.SSSxxx")
    // return date.toISOString()
  }
}
export function DateForDatabaseV2(date) {
  if (date === null || date === '') {
    return null
  } else {
    if ((date instanceof Date && !isNaN(date)) === false) {
      return null
    }
    return format(date, 'yyyy-MM-dd')
  }
}

export function JSDateToStringDateRelative(date) {
  var today = new Date()
  date = new Date(date)
  var difdays = differenceInDays(today, date)
  var sameDay = today.getDate() === date.getDate()

  let local = {}
  if (GetCulture() === 'nl-NL') {
    local = { locale: nl }
  }
  if (GetCulture() === 'fr-FR') {
    local = { locale: fr }
  }

  if (difdays === 0 && sameDay) {
    return format(date, 'HH:mm', local)
  } else {
    if (difdays <= 6) {
      return format(date, 'EEEEEE HH:mm', local)
    } else {
      return format(date, PEGLOBALS.Xdateformat + ' HH:mm', local)
    }
  }
}

export function jsDateToStringDate(date) {
  return format(date, PEGLOBALS.Xdateformat)
}
export function JSdatetimestring(date) {
  // datum en tijd zonder seconden. datum meegeven als new Date()
  let fulldate = date.toLocaleDateString(GetCulture())
  let hoursminutes = date.toLocaleTimeString().replace(/(.*)\D\d+/, '$1')
  return fulldate + ' ' + hoursminutes
}

export function parseDate(date) {
  let dateParts

  if (date === undefined || date === null || date === '') {
    return null
  } else {
    try {
      if (GetCulture() === 'en-US') {
        return new Date(date)
      } else if (GetCulture() === 'nl-NL' || GetCulture() === 'nl-BE') {
        dateParts = date.split('-')
        if (parseInt(dateParts[1]) > 12) {
          return date
        }
        if (parseInt(dateParts[2]) < 1900) {
          return date
        }
        if (parseInt(dateParts[0]) > 31) {
          return date
        }
        return new Date(dateParts[2], dateParts[1] - 1, dateParts[0])
      } else if (GetCulture() === 'fr-BE' || GetCulture() === 'fr-FR') {
        dateParts = date.split('/')
        return new Date(dateParts[2], dateParts[1] - 1, dateParts[0])
      } else if (GetCulture() === 'de-DE') {
        dateParts = date.split('-')
        return new Date(dateParts[2], dateParts[1] - 1, dateParts[0])
      } else {
        dateParts = date.split('-')
        return new Date(dateParts[2], dateParts[1] - 1, dateParts[0])
      }
    } catch (e) {
      return date // ik misbruik undefined hier, voor de validator betekent undefined NOT VALID
    }
  }
}

/**
 * er een rererrer is ga er naar toe (url waar je vandaan komt)
 *
 * @export
 * @returns false or true, false als redirect niet lukt
 */
export function gotoUrlReferrer() {
  this.refurl = UgetCookie('strAppUrlReferrer')

  if (this.refurl !== '') {
    // window.location = updateQueryStringParameter(this.refurl,'random',Math.random())
    window.location = this.refurl
    return true
  } else {
    window.history.back()
  }
  return false
}
/**
 *
 *  als er een rererrer is geeft ie die terug (url waar je vandaan komt)
 * @export
 * @returns
 */
export function getUrlReferrer() {
  this.refurl = UgetCookie('strAppUrlReferrer')

  return this.refurl !== ''
}

// function updateQueryStringParameter(uri, key, value) {
//   var re = new RegExp('([?&])' + key + '=.*?(&|#|$)', 'i')
//   if (uri.match(re)) {
//     return uri.replace(re, '$1' + key + '=' + value + '$2')
//   } else {
//     var hash = ''
//     if (uri.indexOf('#') !== -1){
//         hash = uri.replace(/.*#/, '#')
//         uri = uri.replace(/#.*/, '')
//     }
//     var separator = uri.indexOf('?') !== -1 ? '&' : '?'
//     return uri + separator + key + '=' + value + hash
//   }
// }
export const settings = {
  authorized: false,
  apikey: null,
  debug: false,
  session: {
    SES_taalid: 1,
    SES_defaulttaalid: 1,
    SES_profid: 55,
    SES_orgid: 19,
    SES_personid: 10201
  }
}

export function RequestInt(reqkey = '') {
  const url = new URL(window.location.href)
  const val = Number.parseInt(url.searchParams.get(reqkey))
  return val
}

/**
 * haal data op voor XVtable component
 *
 * @export
 * @param {any} inputparssp - StoredProcedure
 * @returns dataset met data
 */
export async function GetXVTableData(inputparssp, input = {}) {
  let xvTable = {
    tablesetting: {},
    tablecolumnsetting: [],
    tabledata: []
  }
  // vullen via api
  // xvTable.tablecolumnsetting=

  await getDataApi(inputparssp, input).then(data => {
    if (data != null) {
      xvTable.tablesetting = data.ds.data0[0]
      xvTable.tablecolumnsetting = data.ds.data1
      xvTable.tabledata = data.ds.data2
    }
  })
  return xvTable
}
export async function GetXVTableDataV2(inputparssp, input = {}) {
  let xvTable = {
    tabledata: []
  }
  await getDataApi(inputparssp, input).then(data => {
    var size = Object.keys(data.ds).length
    if (data != null) {
      size === 1 ? (xvTable.tabledata = data.ds.data0) : (xvTable.tabledata = data.ds.data2)
    }
  })
  return xvTable
}

/**
 * Adds two numbers
 * @param {String} name
 * @param {Object} reqdata
 * @param {Boolean} returnerror
 * @return {Object} promise with data
 */
export function getDataApi(name, reqdata = {}, returnerror = false) {
  var promise = new Promise(async function(resolve, reject) {
    // reqdata = _.merge(settings.session, reqdata);

    // set taal, als het een public pagina is pakken we een public cookie zodat deze niet interfereert met sessies van een eventuele ingelogde gebruiker
    let inttaal
    let defaulttaalid
    if (window.location.href.indexOf('peapp/public') === -1) {
      inttaal = UgetCookieAsInt('LanguageId')
      defaulttaalid = UgetCookieAsInt('DefaultLanguageId')
    } else {
      inttaal = UgetCookieAsInt('PublicLanguageId')
      defaulttaalid = UgetCookieAsInt('PublicDefaultLanguageId')
    }

    let role = UgetCookie('pe_UserInRole')

    reqdata.SES_taalid = inttaal === '' ? 1 : inttaal
    reqdata.SES_defaulttaalid = defaulttaalid === '' ? 1 : defaulttaalid
    reqdata.SES_Dateformat = window.Xdateformat
    reqdata.SES_rol = role
    reqdata.SES_personid = UgetCookieAsInt('pe_PersonID')
    if (!reqdata.SES_bergrpid) {
      reqdata.SES_bergrpid = UgetCookieAsInt('pe_activeProfGroup')
    }
    reqdata.SES_orgid = UgetCookieAsInt('pe_activeProfOrg')
    reqdata.SES_extorgid = UgetCookieAsInt('pe_ExtOrgId')
    reqdata.SES_Subrollen = UgetCookie('pe_Subroles')

    // if (!PRODUCTION) {
    //   PEGLOBALS.apiurl = 'https://localapi.xaurum.nl/'
    // }

    const token = await getTokenAsync()

    // choose which api to use
    let urlRole = ''
    let apiobj
    if (name.startsWith('public/')) {
      apiobj = HTTPapiPublic
    } else {
      apiobj = HTTPapi
      urlRole = '/' + role
    }
    apiobj(token)
      .post(`/` + name + urlRole, reqdata)
      .then(response => {
        resolve(response.data)
      })
  })
  return promise
}

export function timeout(ms) {
  return new Promise(resolve => setTimeout(resolve, ms))
}

// generator functie die async functies sync afhandeld https://towardsdatascience.com/javascript-generator-yield-next-async-await-8442d2c77185
export async function* generateApiSequence(apipath, Datasets, to = 0) {
  for (let i = 0; i <= Datasets.length - 1; i++) {
    // yay, can use await!
    await getDataApi(apipath, Datasets[i])
    await timeout(to)
    yield Datasets[i]
  }
}

export function getDataApiLocal(name, reqdata = {}, returnerror = false, internal = false, withTransids = true) {
  var promise = new Promise(function(resolve, reject) {
    // reqdata = _.merge(settings.session, reqdata);

    // set taal
    if (withTransids === true) {
      let inttaal = UgetCookieAsInt('LanguageId')
      let defaulttaalid = UgetCookieAsInt('DefaultLanguageId')
      reqdata.SES_taalid = inttaal === '' ? 1 : inttaal
      reqdata.SES_defaulttaalid = defaulttaalid === '' ? 1 : defaulttaalid
      reqdata.SES_Dateformat = PEGLOBALS.Xdateformat
    }

    HTTPapiLocal(true)
      .post(`/` + name, reqdata)
      .then(response => {
        resolve(response.data)
      })
  })
  return promise
}
export function getData(name, reqdata) {
  var promise = new Promise(function(resolve, reject) {
    HTTP.post(name, reqdata)
      .then(response => {
        resolve(response.data)
      })
      .catch(e => {
        resolve(null)
        throw e
      })
  })
  return promise
}
export function rad(x) {
  return (x * Math.PI) / 180
}
export function getDistance(p1, p2) {
  var R = 6378137 // Earth's mean radius in meter
  var dLat = this.rad(p2.lat() - p1.lat())
  var dLong = this.rad(p2.lng() - p1.lng())
  var a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(this.rad(p1.lat())) * Math.cos(this.rad(p2.lat())) * Math.sin(dLong / 2) * Math.sin(dLong / 2)
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
  var d = R * c
  return d // returns the distance in meter
}

export function showVueMessageAfterRedirect(bericht, ccskleur = 'gritter-primary', sticky = false, titeltext = '') {
  let jsonstring = JSON.stringify({
    title: titeltext,
    message: bericht,
    className: ccskleur,
    sticky: sticky
  })
  UsetCookie('jsongritter', jsonstring)
}

export function newpageinit() {
  scrollToTop()
  if (window.valmessageid !== null) {
    $.gritter.remove(window.valmessageid)
  }
  window.valmessageid = null
}

export function ClearSessionStorage() {}

export function UgetCookie(cname) {
  var name = cname + '='
  var decodedCookie = decodeURIComponent(document.cookie)
  var ca = decodedCookie.split(';')
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i]
    while (c.charAt(0) === ' ') {
      c = c.substring(1)
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length)
    }
  }
  return ''
}

export function UgetCookieAsInt(cname) {
  var cookieValue = UgetCookie(cname)
  var result = parseInt(cookieValue, 10)

  if (isNaN(result)) {
    return null
  }

  return result
}

export function UsetCookie(cname, cvalue, expirationInSeconds) {
  var expires = 'expires=1'
  if (expirationInSeconds) {
    var d = new Date()
    d.setTime(d.getTime() + expirationInSeconds * 1000)
    expires = 'expires=' + d.toUTCString()
  }

  document.cookie = cname + '=' + cvalue + ';' + expires + ';secure;path=/'
}

// scroll naar div id
window.goToByScroll = function(id) {
  // $('html,body').animate({scrollTop: $('#' + id).offset().top - CalcHeightheader()},'slow')
  $('html,body').animate({ scrollTop: $('#' + id).offset().top - 10 - $('#fixedcontainer').height() + 'px' }, 'slow')
}

export function scrollToTop() {
  window.requestAnimationFrame(() => {
    window.scrollTo(0, 0)
  })
}

let ParameterTypeEnum = {
  String: 1,
  DateTime: 2,
  Integer: 3,
  Decimal: 4
}

/**
 * Adds two numbers
 * @param {Object} parameters
 * @param {Object} NewParameter
 * @param {ParameterTypeEnum} ParameterType
 * @return {Object} promise with data
 */
export function AddParamaterForDB(parameters, ParameterKey, ParameterValue, ParameterType) {
  if (ParameterTypeEnum.String === ParameterType) {
    return parameters.push({
      key: ParameterKey,
      value: ParameterValue,
      DateTime: '',
      intvalue: '',
      decimalvalue: ''
    })
  }
  if (ParameterTypeEnum.Integer === ParameterType) {
    return parameters.push({
      key: ParameterKey,
      value: '',
      DateTime: '',
      intvalue: ParameterValue,
      decimalvalue: ''
    })
  }
  if (ParameterTypeEnum.Decimal === ParameterType) {
    return parameters.push({
      key: ParameterKey,
      value: '',
      DateTime: '',
      intvalue: '',
      decimalvalue: ParameterValue
    })
  }
  if (ParameterTypeEnum.DateTime === ParameterType) {
    return parameters.push({
      key: ParameterKey,
      value: '',
      DateTime: ParameterValue,
      intvalue: '',
      decimalvalue: ''
    })
  }
}

export function format2decimal(value) {
  if (value === undefined || value === null) return ''
  return value.toLocaleString(GetCulture())
}

export function PrepareTableForExport(table, tablecolumnsetting, columnDefinition) {
  let columnrow = {}
  let returntable
  for (var propertyName in table[0]) {
    tablecolumnsetting.forEach(col => {
      if (col.tblPEapiProcTableColumnName === propertyName) {
        columnrow[propertyName] = col.columnname
      }
    })
  }

  table.unshift(columnrow)
  returntable = table.map(row => {
    let newrow = {}

    columnDefinition.forEach(coldef => {
      tablecolumnsetting.forEach(col => {
        if (col.tblPEapiProcTableColumnName === coldef.name && col.tblPEapiProcTableColumnVisible === 1) {
          coldef.headerColName = col.columnname
          newrow[coldef.name] = row[coldef.name]
          coldef.visible = true
        }
        if (col.tblPEapiProcTableColumnName === coldef.name && col.tblPEapiProcTableColumnVisible === 0) {
          coldef.visible = false
        }
      })
    })
    return newrow
  })

  return returntable
}
export function PrepareTableForExportPDF(table, tablecolumnsetting) {
  // let columnrow = {}
  // // let returntable
  // for (var propertyName in table[0]) {
  //   tablecolumnsetting.forEach((col) => {
  //   if (col.tblPEapiProcTableColumnName === propertyName && col.tblPEapiProcTableColumnVisible === 1 && col.tblPEapiProcTableColumnName !== 'tableRowState'){
  //     columnrow[propertyName] = col.columnname
  //   }
  // })
  // }

  let returntable = table.map(row => {
    let newrow = {}

    tablecolumnsetting.forEach(col => {
      if (col.tblPEapiProcTableColumnName !== 'tableRowState') {
        newrow[col.tblPEapiProcTableColumnName] = row[col.tblPEapiProcTableColumnName]
      }
      // if (col.tblPEapiProcTableColumnName === coldef.name && col.tblPEapiProcTableColumnVisible === 0){
      //   coldef.visible = false
      // }
    })

    return newrow
  })
  // returntable.unshift(columnrow)
  return returntable
}

export async function GenerateFile(route, params) {
  if (params.local) {
    return getDataApiLocal(route, params)
  } else {
    return getDataApi(route, params)
  }
}

export function download(sp, params) {
  if (params.local) {
    return getDataApiLocal(sp, params).then(downloaddata => {
      if (downloaddata != null) {
        window.location = createApiUrl(downloaddata.url)
      }
    })
  } else {
    return getDataApi(sp, params).then(downloaddata => {
      if (downloaddata != null) {
        window.location = createApiUrl(downloaddata.url)
      }
    })
  }
}
export async function isLoggedIn() {
  const token = await getTokenAsync()
  if (token && jwtDecode(token).sub) {
    return true
  }

  return false
}

// helper dunctie die een functie een tijdje niet uitvoert en daarna 1 keer (delay)
export const debounced = (time, fn) => {
  let timeout

  return function() {
    const functionCall = () => fn.apply(this, arguments)

    clearTimeout(timeout)
    timeout = setTimeout(functionCall, time)
  }
}

// helper dunctie die een functie een tijdje niet uitvoert en daarna 1 keer en dan weer een tijdje niet (delay)
export function throttled(delay, fn) {
  let lastCall = 0
  return (...args) => {
    const now = new Date().getTime()
    if (now - lastCall < delay) {
      return
    }
    lastCall = now
    return fn(...args)
  }
}

let getTokenPromise = null

export async function getTokenAsync() {
  if (UgetCookie('kongapikey')) {
    return UgetCookie('kongapikey')
  }
  
  if (UgetCookie('kongapirefreshtoken')) {

    if (!getTokenPromise) {
      getTokenPromise = refreshTokenInVB()
    }
    const result = await getTokenPromise
    if (result && result.data && result.data.access_token) {
      UsetCookie('kongapikey', result.data.access_token, jwtDecode(result.data.access_token).exp - Date.now())
    }
    getTokenPromise = null

    return UgetCookie('kongapikey')
  }
}

function refreshTokentimer() {
  const timeout = 1 * 60 * 1000 // 1 min * 60 sec * 1000 milliseconds
  setTimeout(() => CheckTokenAsync(), timeout)
}

export async function CheckTokenAsync() {
  await getTokenAsync()

  if (UgetCookie('kongapikey')) {
    const claims = jwtDecode(UgetCookie('kongapikey'))
  
    // If we have a sub claim we know that it's an ID token
    if (claims && claims.sub) {
      // Get the expiration date
      const expiration = new Date(+claims.exp * 1000)
  
      // If it's less then the 1 min timer then refresh immidiatly
      const remainingTime = expiration.getTime() - Date.now()
      if (remainingTime < 60000) {
        const result = await refreshTokenInVB()
        if (result && result.data && result.data.access_token) {
          UsetCookie('kongapikey', result.data.access_token, jwtDecode(result.data.access_token).exp - Date.now())
        }
      }
    }
  }

  // Restart the cycle
  refreshTokentimer()
}

export function refreshTokenInVB() {
  const axiosInstance = axios.create()

  axiosInstance.interceptors.response.use(undefined, function axiosRetryInterceptor(error) {
    // jwt verlopen of andere error die toegang tot resource tegenhoud
    if (error.response && error.response.status === 302 && error.response.data && error.response.data.PEReturnUrl) {
      window.location = error.response.data.PEReturnUrl
      return
    }

    if (error.response) {
      // status gevuld, dus geen newtork error, netwerk errors negeren, anderen loggen
      throwException('onbekende fout tijdens PErefreshtoken', {
        Error: error
      })
    } else {
      console.error('Network Error, check your internet connextion', error)
    }

    return Promise.reject(error)
  })

  return axiosInstance.post('/components/js/PErefreshtoken.ashx', {})
}

export function CalcHeightheader() {
  // You could easily calculate this dynamically if you prefer
  // Alleen als de content div bestaat gaan we de positie van de ankers verplaatsen, wel altijd een animatie ook als contentdiv niet bestaat
  // uitgezet dit gebeurd nu met css in _clientskin.scss

  let fromTop = parseInt($('#fixedcontainer').height())

  // check if mobileheader is visible on public page
  if (fromTop === 0 && $('body').hasClass('bodyPublic') === true) {
    fromTop = $('.mobileheaderbackground').height() + $('.FAContainer').height()
  }

  return fromTop
}

export function MakeSticky(HeaderParentClass, StickyHeaderChildClass) {
  var isIE11 = !!window.MSInputMethodContext && !!document.documentMode
  if (isIE11) {
    $(window).scroll(function() {
      var scrollTop = $(window).scrollTop()
      $(StickyHeaderChildClass).css('width', $(HeaderParentClass).width())
      if (scrollTop > 50) {
        $(StickyHeaderChildClass).addClass('fixed')
      } else {
        $(StickyHeaderChildClass).removeClass('fixed')
      }
      $(StickyHeaderChildClass).css('top', $('#fixedcontainer').height())
    })
  }
}

export function GetCulture() {
  let culture = 'nl-NL'
  if (window.location.href.indexOf('peapp/public') === -1) {
    culture = UgetCookie('Culture')
  } else {
    culture = UgetCookie('PublicCulture')
  }

  return culture
}

export function firstCharToLowerCase(string) {
  return string.charAt(0).toLowerCase() + string.slice(1)
}

export function createApiUrl(relativeUrl) {
  if (
    (!PEGLOBALS.apiurl.endsWith('/') && relativeUrl.startsWith('/')) ||
    (PEGLOBALS.apiurl.endsWith('/') && !relativeUrl.startsWith('/'))
  ) {
    return PEGLOBALS.apiurl + relativeUrl
  } else if (PEGLOBALS.apiurl.endsWith('/') && relativeUrl.startsWith('/')) {
    return PEGLOBALS.apiurl.slice(0, -1) + relativeUrl
  }

  return PEGLOBALS.apiurl + '/' + relativeUrl
}

export async function createUrqlClient(url) {
  const token = UgetCookie('kongapikey')
    ? await getTokenAsync()
    : await this.requestAccessToken()

  return createClient({
    url: createApiUrl(url),
    fetchOptions: () => {
      return {
        headers: { authorization: `Bearer ${token}` }
      }
    }
  })
}

export async function requestAccessToken(){
  try {
    const API_BASE_URL = PEGLOBALS.idsurl

    const axiosConfig = {
        baseURL: API_BASE_URL,
        timeout: 30000,
        withCredentials: false,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    }

    const requestData = {
        client_id: process.env.VUE_APP_API_CLIENT_ID,
        client_secret: process.env.VUE_APP_API_CLIENT_SECRET,
        scope: 'coreapi',
        grant_type: 'client_credentials'
    }
    const result = await axios.post('/connect/token', new URLSearchParams(requestData), axiosConfig)

    UsetCookie('kongapikey', result.data.access_token, +result.data.expires_in - 120)

    return result.data.access_token
  } catch {
    return null
  }
}

export async function coreApiGet(url, params) {
  const token = UgetCookie('kongapikey')
    ? await getTokenAsync()
    : await this.requestAccessToken()
  var apiUrl = this.createApiUrl(`${url}${escape(params)}`)
  var promise = new Promise(function(resolve, reject) {
    axios({ method: 'get', url: apiUrl, headers: { 'Authorization': 'Bearer ' + token } }).then(response => {
      resolve(response.data)
    })
  })
  return promise
}

export function combineUri(base, relative) {
    if (base.endsWith('/') && relative.startsWith('/')) {
        return base + relative.substr(1, relative.length)
    }
    if (!base.endsWith('/') && !relative.startsWith('/')) {
        return `${base}/${relative}`
    }
    return base + relative
}

// naam aanpassen
export function postData(name, reqdata = {}, returnerror = false) {
  var promise = new Promise(function(resolve, reject) {
    const token = UgetCookie('kongapikey')
    const config = {
      headers: { Authorization: `Bearer ${token}` }
    }
    axios.post(combineUri(PEGLOBALS.apiurl, name), reqdata, config).then(response => {
      resolve(response.data)
    })
  })
  return promise
}
export function putData(name, reqdata = {}, returnerror = false) {
  var promise = new Promise(function(resolve, reject) {
    const token = UgetCookie('kongapikey')
    const config = {
      headers: { Authorization: `Bearer ${token}` }
    }
    axios.put(combineUri(PEGLOBALS.apiurl, name), reqdata, config).then(response => {
      resolve(response.data)
    })
  })
  return promise
}
export function deleteData(name, id, returnerror = false) {
  var promise = new Promise(function(resolve, reject) {
    const token = UgetCookie('kongapikey')
    const config = {
      headers: { Authorization: `Bearer ${token}` }
    }
    axios.delete(combineUri(PEGLOBALS.apiurl, name) + '?id=' + id, config).then(response => {
      resolve(response.data)
    })
  })
  return promise
}
